import React from 'react'
import FeaturePage from 'Event/template/Lefty/Page'
import FaqList from 'Event/template/Lefty/FAQs/FaqList'
import {User} from 'auth/user'
import {
  FeaturePageTitle,
  PageTexts,
  StyledConfigurable,
} from 'Event/template/Lefty/Page'
import {useAttendeeVariables} from 'Event'
import {useLeftyTemplate} from 'Event/template/Lefty'
import AddFaqButton from 'Event/FAQs/AddFaqButton'
import {LeftyBreadcrumbs} from 'Event/template/Lefty/Page'
import FaqsHeaderConfig from 'Event/template/Lefty/FAQs/FaqsHeaderConfig'

export default function Faqs(props: {user: User}) {
  const template = useLeftyTemplate()
  const {faq: pageSettings} = template
  const v = useAttendeeVariables()

  return (
    <FeaturePage user={props.user}>
      <StyledConfigurable>
        <FaqsHeaderConfig />
        <>
          <FeaturePageTitle aria-label="faqs title">
            {v(pageSettings?.title)}
          </FeaturePageTitle>
          <LeftyBreadcrumbs page={v(pageSettings.title)} />
          <PageTexts
            title={pageSettings.secondaryTitle}
            description={pageSettings.description}
          />
        </>
      </StyledConfigurable>
      <AddFaqButton />
      <FaqList />
    </FeaturePage>
  )
}
